(function () {
    'use strict';

    angular
        .module('app.cookiepolicy', [
            'app.core',
            'utils'
        ]);
})();